export { default } from './LazySavedCourses';
